import jwt_decode from "jwt-decode";
import moment from 'moment';

const GetJsonFromLocalStorage = (key) => JSON.parse(localStorage.getItem(key));

const GetLoggedInUserToken = () => GetJsonFromLocalStorage('user').token;

const SaveItemInLocalStorage = (key, value) => localStorage.setItem(key, JSON.stringify(value));

const IsUserLoggedIn = () => {
    let loggedInUser = GetJsonFromLocalStorage('user');
    if (loggedInUser === null)
        return false;
    try {
        var decoded = jwt_decode(loggedInUser.token);

        return decoded.Role;
    } catch (ex) {
        return false;
    }

}

const LoggedInUserRole = () => {
    let loggedInUser = GetJsonFromLocalStorage('user');
    if (loggedInUser === null)
        return false;
    try {
        var decoded = jwt_decode(loggedInUser.token);

        return decoded.Role == "" ? -1 : decoded.Role;
    } catch (ex) {
        return false;
    }
}

const LoggedInUserId = () => {
    let loggedInUser = GetJsonFromLocalStorage('user');
    if (loggedInUser === null)
        return false;
    try {
        var decoded = jwt_decode(loggedInUser.token);

        return decoded.UserId;
    } catch (ex) {
        return false;
    }
}

const LoggedInCompanyId = () => {
    let loggedInUser = GetJsonFromLocalStorage('user');
    if (loggedInUser === null)
        return false;
    try {
        var decoded = jwt_decode(loggedInUser.token);

        return decoded.CompanyId;
    } catch (ex) {
        return false;
    }
}

const IsLoggedInUserSalesCoach = () => {
    let loggedInUser = GetJsonFromLocalStorage('user');
    if (loggedInUser === null)
        return false;
    try {
        var decoded = jwt_decode(loggedInUser.token);

        return decoded.IsSalesCoach;
    } catch (ex) {
        return false;
    }
}

const ConvertJsonToFormData = (json) => {
    var form_data = new FormData();
    for (var key in json) {
        if (Array.isArray(json[key]))
            json[key].forEach(item => form_data.append(key, item));
        else if (typeof json[key] == 'object' && !key.includes('File')) {
            for (var innerKey in json[key])
                form_data.append(`${key}[0][${innerKey}]`, json[key][innerKey]);
        }
        else
            form_data.append(key, (json[key] === null) ? "" : json[key]);
    }

    return form_data;
}

const SetOptionModel = (name, value = null) => {
    return name == undefined ? null : { label: name, value: value ? value : name };
}

const FormatToUSDate = (date) => {
    var momentDate = moment(date);

    return (momentDate.isValid()) ? momentDate.format("MM/DD/yyyy") : null;
}

const GetMonthOptionsForDuration = (duration) => {
    var dates = [];
    var startOfCurrentMonth = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1);
    dates.push(startOfCurrentMonth.toLocaleString('default', { month: 'long' }) + ' ' + startOfCurrentMonth.getUTCFullYear());
    for (var i = 1; i <= duration; i++) {
        var nextMonth = new Date(startOfCurrentMonth.setMonth(startOfCurrentMonth.getUTCMonth() + 1));
        dates.push(nextMonth.toLocaleString('default', { month: 'long' }) + ' ' + nextMonth.getUTCFullYear());
    }

    return dates;
}

const ReOrderDnd = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result.map((x, i) => ({ ...x, sortOrder: i }));
};

export {
    GetJsonFromLocalStorage,
    GetLoggedInUserToken,
    SaveItemInLocalStorage,
    IsUserLoggedIn,
    LoggedInUserRole,
    LoggedInUserId,
    LoggedInCompanyId,
    ConvertJsonToFormData,
    SetOptionModel,
    FormatToUSDate,
    IsLoggedInUserSalesCoach,
    GetMonthOptionsForDuration,
    ReOrderDnd
}